let globalMethod = {};
     // 导航按钮
globalMethod.goStatic= function  () {
     this.$router.push({
      path: '/search',
      query: {
        gameName: this.gameName
      }
    })
  }
//    页面游戏下载按钮
globalMethod.gameDownload= function (tag, data) {
    let formData = new FormData();
    formData.append('channel', 1);
    formData.append('system', data);
    formData.append('tag', tag);
    this.$apiFun.gameDown(formData).then((res) => {
    })
  }
  
export default globalMethod;


// WEBPACK FOOTER //
// ./src/static/js/index.js